import { GuidedCourseNextStepsV1NaptimeResource } from './__generated__/GuidedCourseNextStepsV1';

export default class GuidedCourseNextSteps extends GuidedCourseNextStepsV1NaptimeResource {
  static RESOURCE_NAME = 'guidedCourseNextSteps.v1' as const;
}
